const indiaConfig = require("./indiaApiRegistery");
const sriLankaConfig = require("./srilankaApiRegistery");
const bangladeshConfig = require("./bangladeshApiRegistery");

module.exports = {
  india : ({endpoints, checkIfIsMiniApp})=>indiaConfig({endpoints, checkIfIsMiniApp}),
  sriLanka: ({endpoints, checkIfIsMiniApp})=>sriLankaConfig({endpoints, checkIfIsMiniApp}),
  bangladesh: ({endpoints, checkIfIsMiniApp})=>bangladeshConfig({endpoints, checkIfIsMiniApp})
}